module.exports = __webpack_public_path__ + "assets/img/entico3.3f949a4f.jpg";